<div class="roadmap" id="roadmap">
    <app-road-background></app-road-background>
    <div class="container position-relative">
        <div class="roadmap-content position-relative">
            <h2 class="section-title text-center text-white">{{ "roadmap.title" | translate}}</h2>
            <p class="section-desc font-16 font-md-24">{{ "roadmap.desc" | translate}}</p>

            <div class="mt-5">
                <owl-carousel-o [options]="slideOption" *ngIf="!isMobile() && isRender()">
                    <ng-template carouselSlide
                        *ngFor="let item of translatedItems(); let i = index; trackBy: trackByIndex">
                        <div class="roadmap-card">
                            <div [className]="'line line-' + i"></div>
                            <!-- <div class="vertical-line"></div> -->
                            <div class="icon d-flex justify-content-center align-items-center">
                                <svg-icon src="/assets/images/svg-icons/{{item.icon}}.svg"
                                    [svgStyle]="{ 'width.px': '24', 'height.px': '24' }" loading="lazy"></svg-icon>
                            </div>
                            <div [className]="'inner-card ' + item.icon">
                                <div class="badge mb-3">{{ item.timing }}</div>
                                <p class="font-16 fw-regular text-tertiary mb-1">{{ "roadmap.phase" | translate}} {{ i +
                                    1 }}
                                </p>
                                <p class="font-24 fw-regular text-white">{{ item.title}}</p>
                                <div class="roadmap-content d-flex flex-column">
                                    <ul class="roadmap-list">
                                        <li *ngFor="let list of item.list" class="font-14 font-sm-16 text-light-grey">
                                            <svg-icon
                                                src="/assets/images/svg-icons/{{item.icon === 'upcoming' ? 'list-icon-upcoming' : 'list-icon'}}.svg"
                                                [className]="'list-icon ' + item.icon" loading="lazy"></svg-icon>
                                            <span [innerHTML]=" list"></span>
                                        </li>
                                    </ul>
                                    <div class="details d-flex flex-column gap-1" *ngIf="!i">
                                        <p class="text-white font-16 m-0">{{ "roadmap.phase_1_stage1" | translate}}</p>
                                        <p class="text-white font-16 m-0">{{ "roadmap.phase_1_stage2" | translate}}</p>
                                        <p class="text-white font-16 m-0">{{ "roadmap.phase_1_stage3" | translate}}</p>
                                        <ul class="sub-list ms-3 mt-2">
                                            <li class="font-16 text-light-grey">{{
                                                "roadmap.phase_1_sub_point1" | translate}}
                                            </li>
                                            <li class="font-16 text-light-grey">
                                                {{
                                                "roadmap.phase_1_sub_point2" | translate}}
                                            </li>
                                            <li class="font-16 text-light-grey">

                                                {{
                                                "roadmap.phase_1_sub_point3" | translate}}
                                            </li>
                                        </ul>
                                    </div>
                                    <p class="font-16 m-0 fw-regular text-white">{{ item.outcome}}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </owl-carousel-o>
                <div *ngIf="isMobile()" class="d-flex align-items-start carousel-mobile">
                    <div class="roadmap-card"
                        *ngFor="let item of translatedItems(); let i = index; trackBy: trackByIndex">
                        <div [className]="'line line-' + i"></div>
                        <!-- <div class="vertical-line"></div> -->
                        <div class="icon d-flex justify-content-center align-items-center">
                            <svg-icon src="/assets/images/svg-icons/{{item.icon}}.svg"
                                [svgStyle]="{ 'width.px': '24', 'height.px': '24' }" loading="lazy"></svg-icon>
                        </div>
                        <div [className]="'inner-card ' + item.icon">
                            <div class="badge mb-3">{{ item.timing }}</div>
                            <p class="font-16 fw-regular text-tertiary mb-1">{{ "roadmap.phase" | translate}} {{ i +
                                1 }}
                            </p>
                            <p class="font-24 fw-regular text-white">{{ item.title }}</p>
                            <div class="roadmap-content d-flex flex-column">
                                <ul class="roadmap-list">
                                    <li *ngFor="let list of item.list" class="font-14 font-sm-16 text-light-grey">
                                        <svg-icon
                                            src="/assets/images/svg-icons/{{item.icon === 'upcoming' ? 'list-icon-upcoming' : 'list-icon'}}.svg"
                                            [className]="'list-icon ' + item.icon" loading="lazy"></svg-icon>
                                        <span [innerHTML]="list"></span>
                                    </li>
                                </ul>
                                <div class="details d-flex flex-column gap-1" *ngIf="!i">
                                    <p class="text-white font-14 font-md-16 m-0">{{ "roadmap.phase_1_stage1" |
                                        translate}}</p>
                                    <p class="text-white font-14 font-md-16 m-0">{{ "roadmap.phase_1_stage2" |
                                        translate}}</p>
                                    <p class="text-white font-14 font-md-16 m-0">{{ "roadmap.phase_1_stage3" |
                                        translate}}</p>
                                    <ul class="sub-list ms-3 mt-2">
                                        <li class="font-14 font-sm-16 text-light-grey">{{
                                            "roadmap.phase_1_sub_point1" | translate}}
                                        </li>
                                        <li class="font-14 font-sm-16 text-light-grey">
                                            {{
                                            "roadmap.phase_1_sub_point2" | translate}}
                                        </li>
                                        <li class="font-14 font-sm-16 text-light-grey">

                                            {{
                                            "roadmap.phase_1_sub_point3" | translate}}
                                        </li>
                                    </ul>
                                </div>
                                <p class="font-14 m-0 fw-regular text-white">{{ item.outcome }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="text-center font-16 text-scroll text-white">{{ "roadmap.scroll" | translate }}</p>
            </div>
        </div>
        <!-- <video autoplay muted loop playsinline class="bg-video position-absolute h-100">
            <source src="assets/images/videos/roadmap-bg.mp4" type="video/mp4" />
            Your browser does not support the video tag.
        </video> -->
    </div>

    <div class="container">
        <div class="cta-card">
            <div class="text-center">
                <h4 class="font-24 mb-3 fw-regular text-white">{{ "roadmap.global_finance" | translate }}</h4>
                <p class="font-16 mb-0 fw-light text-light-grey">{{ "roadmap.global_finance_desc" | translate }}</p>
            </div>
        </div>
    </div>
</div>